export default '1.25.0';
